import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/chat/inVideoSuccess.svg'
import _imports_1 from '@/assets/chat/outVideoSuccess.svg'
import _imports_2 from '@/assets/chat/inVoiceSuccess.svg'
import _imports_3 from '@/assets/chat/outVoiceSuccess.svg'
import _imports_4 from '../../../assets/chat/defaultPhone.svg'


const _withScopeId = n => (_pushScopeId("data-v-3a566e30"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "phoneItem" }
const _hoisted_2 = { class: "leftBox" }
const _hoisted_3 = {
  key: 0,
  src: _imports_0,
  alt: ""
}
const _hoisted_4 = {
  key: 1,
  src: _imports_1,
  alt: ""
}
const _hoisted_5 = {
  key: 2,
  src: _imports_2,
  alt: ""
}
const _hoisted_6 = {
  key: 3,
  src: _imports_3,
  alt: ""
}
const _hoisted_7 = {
  key: 4,
  src: _imports_4,
  alt: ""
}
const _hoisted_8 = {
  key: 5,
  class: "imgBox_gray"
}
const _hoisted_9 = { class: "middleBox" }
const _hoisted_10 = { class: "name" }
const _hoisted_11 = { class: "username wordHidden" }
const _hoisted_12 = {
  key: 0,
  class: "count"
}
const _hoisted_13 = { class: "status" }
const _hoisted_14 = { class: "rightBox" }

import { ref, watch, computed } from "vue";
import { dateFormat } from "@/utils/format";
import { useI18n } from "vue-i18n";


export default /*#__PURE__*/_defineComponent({
  __name: 'phoneItem',
  props: {
  item: {
    type: Object,
    required: true,
  },
},
  setup(__props) {

const props = __props;

const { t } = useI18n();



const newStatus = ref();
watch(
  () => props.item,
  () => {
    if (!props.item) return;
    if (!props.item.status) return;

    if (props.item.status == "incoming video") {
      newStatus.value = { name: computed(() => t("chat.incomingVideo")) };
    } else if (props.item.status == "outgoing video") {
      newStatus.value = { name: computed(() => t("chat.outgoingVideo")) };
    } else if (props.item.status == "incoming voice") {
      newStatus.value = { name: computed(() => t("chat.incomingVoice")) };
    } else if (props.item.status == "outgoing voice") {
      newStatus.value = { name: computed(() => t("chat.outgoingVoice")) };
    } else {
      newStatus.value = { name: props.item.status };
    }
  },
  {
    immediate: true,
  }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (__props.item.status == 'incoming video')
        ? (_openBlock(), _createElementBlock("img", _hoisted_3))
        : (__props.item.status == 'outgoing video')
          ? (_openBlock(), _createElementBlock("img", _hoisted_4))
          : (__props.item.status == 'incoming voice')
            ? (_openBlock(), _createElementBlock("img", _hoisted_5))
            : (__props.item.status == 'outgoing voice')
              ? (_openBlock(), _createElementBlock("img", _hoisted_6))
              : (_openBlock(), _createElementBlock("img", _hoisted_7)),
      (__props.item.status.toLowerCase().trim() == '')
        ? (_openBlock(), _createElementBlock("div", _hoisted_8))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("span", _hoisted_11, _toDisplayString(__props.item.contact_name || "--"), 1),
        (__props.item.count > 1)
          ? (_openBlock(), _createElementBlock("span", _hoisted_12, "(" + _toDisplayString(__props.item.count) + ")", 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_13, _toDisplayString(newStatus.value.name || "--"), 1)
    ]),
    _createElementVNode("div", _hoisted_14, _toDisplayString(_unref(dateFormat)(__props.item.date, "YYYY-MM-DD HH:mm") || "--"), 1)
  ]))
}
}

})